import Position from './Position';

/**
 * Class describing the values and functions of a Place of Interest (POI)
 * Places of Interest are used to describe the attributes of an intersting space
 *
 * @export {POI}
 * @class POI
 */

export default class POI {
    constructor (id, title, category, description, map) {
        this._id = id;
        this._title = title;
        this._category = category;
        this._description = description;
        this._map = map;

        // Uninitialized properties
        this._element = null;
        this._centerPosition = null;
    }

    set element(element) {
        this._element = element;
         // Determine Position of POI
        const POIBBox = this._element.getBBox();
        this._centerPosition = new Position(
            POIBBox.x + (POIBBox.width / 2),
            POIBBox.y + (POIBBox.height / 2),
            // TODO: account for vertical position
            0
        );
    }

    get id() {
        return this._id;
    }

    get element() {
        return this._element;
    }

    get title() {
        return this._title;
    }

    get category() {
        return this._category;
    }

    get description() {
        return this._description;
    }

    get centerPosition() {
        return this._centerPosition;
    }

    get map() {
        return this._map;
    }
}



// WEBPACK FOOTER //
// ./src/classes/POI.js